import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { reissueCard } from '@src/api'
import { DefaultApiReissueCardRequest } from '@src/api/generated/user-api'
import { useGetUserCookieJwt } from '@src/hooks/queries/login/mutations/use-get-user-cookie-jwt/use-get-user-cookie-jwt'
import { useAxios } from '@src/hooks/use-axios'

import { CardReissueErrorResponse } from './type'

export const useReissueCard = () => {
  const { axiosInstance } = useAxios({ apiType: 'THEMIS' })
  const { mutateAsync: getUserCookie } = useGetUserCookieJwt()

  return useMutation<
    unknown,
    AxiosError<CardReissueErrorResponse>,
    DefaultApiReissueCardRequest
  >({
    mutationFn: async (params: DefaultApiReissueCardRequest) => {
      const token = await getUserCookie()
      return reissueCard(axiosInstance, {
        ...params,
        token: token.data.token || null,
      })
    },
  })
}
